import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { printPipes } from '../Api'

export default generateApiAction({
  baseType: Types.PRINT.PIPES,
  api: printPipes,
  responseType: RESPONSETYPE.FILE
})



// WEBPACK FOOTER //
// ./src/actions/print/PrintPipesAction.js